import { createSlice, injectReducers, PayloadAction } from '@apia/store';
import { TPanelId } from '../types';

export type TPanelParameter = string | number | boolean;
export type TParamsStore = Record<string, TPanelParameter>;
export type TParamsSlice = Record<string, TParamsStore>;

const paramsSlice = createSlice({
  initialState: {} as TParamsSlice,
  name: 'panelParameters',
  reducers: {
    udpate(
      state,
      {
        payload,
      }: PayloadAction<{
        panelId: TPanelId;
        parameters: TParamsStore;
      }>,
    ) {
      if (!state[payload.panelId]) state[payload.panelId] = {};

      state[payload.panelId] = {
        ...state[payload.panelId],
        ...payload.parameters,
      };
    },
  },
});

const { store, useSelector } = injectReducers({
  panelParameters: paramsSlice.reducer,
});

export { store as parametersStore, useSelector as useParametersSelector };
export const parametersActions = paramsSlice.actions;
